import $ from 'jquery'; 

//For single-archive.php
//
// Ran on taxonomy-grid block
function fetchArchive(){
    $('.TaxonomyGrid figure > a').on('click',function(e){
        e.preventDefault();
        // data-slug='" . $term->slug 
        let selection = $(this).attr('data-slug');
        let destination = $(this).attr('href');
        localStorage.setItem('archive-selection_protein_type',String(selection));
        window.location.href = destination;
    })
}
fetchArchive();

// function fixTaxGridHeights(){
//     let tallestElement = 0;
//     $.each($('.TaxonomyGrid figure img'), function () { 
//         tallestElement = $(this).outerHeight() > tallestElement ? $(this).outerHeight() : tallestElement;
//         console.log(tallestElement);
//     });
//     $.each($('.TaxonomyGrid figure img'), function (){
//         $(this).css('height',tallestElement);
//     });
// }
// $(window).resize(function(){
//     fixTaxGridHeights();
//  });



//